<div style="display: flex; height: 100%;">
  <div style="display: flex; flex-direction: column; overflow: auto; width: 100%;">
    <div style="display: flex; flex-direction: column; padding: 20px; z-index: 1; ">
      <mat-toolbar color="primary" class="toolbar-over-card"
                   style="padding: 20px; align-items: center; justify-content: space-between;">
        <!-- Title -->
        <div><span>Case Assessment</span></div>
        <div style="display: flex; font-size: medium;">
          <button *ngIf="viewMode === 'table'" mat-button aria-label="Export" (click)="exportToExcel()">
            <div class="fal fa-file-excel" style="font-size: 18px; margin-right: 10px;"></div>
            <span>Export</span>
          </button>
          <button *ngIf="viewMode === 'graph'" mat-button aria-label="Show Table" (click)="viewMode = 'table'">
            <div class="fal fa-table" style="font-size: 18px; margin-right: 10px;"></div>
            <span>Show Table</span>
          </button>
          <button *ngIf="viewMode === 'table'" mat-button aria-label="Graph" (click)="viewMode = 'graph'">
            <div class="fal fa-line-chart" style="font-size: 18px; margin-right: 10px;"></div>
            <span>Graph</span>
          </button>
          <button mat-button aria-label="Add Field" (click)="displayFilterDialog()">
            <div class="fal fa-plus" style="font-size: 18px; margin-right: 10px;"></div>
            <span>Filters</span>
          </button>
        </div>
      </mat-toolbar>
      <mat-card appearance="outlined" class="card-under-toolbar" style="display: flex;">
        <mat-card-content style="flex: auto; display: flex; flex-direction: column; gap: 10px; min-height: 630px">
          <div style="gap: 20px;">
            <mat-form-field appearance="outline" style="flex-grow: 1; width: 30%">
              <mat-label>Report</mat-label>
              <mat-select [(ngModel)]="reportType" (ngModelChange)="refreshReport()">
                <mat-option value="upload-doc-count-by-master-date">Upload: Doc Count by Master Date</mat-option>
                <mat-option value="upload-doc-count-by-custodian">Upload: Doc Count by Custodian</mat-option>
                <mat-option value="upload-page-count-by-custodian">Upload: Page Count by Custodian</mat-option>
                <mat-option value="upload-gigabytes-by-custodian">Upload: Gigabytes by Custodian</mat-option>
                <mat-option value="upload-doc-count-by-doc-source">Upload: Doc Count by Doc Source</mat-option>
                <mat-option value="upload-page-count-by-doc-source">Upload: Page Count by Doc Source</mat-option>
                <mat-option value="upload-gigabytes-by-doc-source">Upload: Gigabytes by Doc Source</mat-option>
                <mat-option value="upload-doc-count-by-extension">Upload: Doc Count by Extension</mat-option>
                <mat-option value="upload-gigabytes-by-extension">Upload: Gigabytes by Extension</mat-option>
                <mat-option value="processing-doc-count-unsupported-by-extension">Processing: Doc Count Unsupported by
                  Extension
                </mat-option>
                <mat-option value="processing-gigabytes-unsupported-by-extension">Processing: Gigabytes Unsupported by
                  Extension
                </mat-option>
                <mat-option value="processing-doc-count-failed-to-convert-by-extension">Processing: Doc Count Failed To
                  Convert by Extension
                </mat-option>
                <mat-option value="processing-gigabytes-failed-to-convert-by-extension">Processing: Gigabytes Failed To
                  Convert by Extension
                </mat-option>
                <mat-option value="review-status-docs">Review: Status Docs</mat-option>
                <mat-option value="review-status-pages">Review: Status Pages</mat-option>
                <mat-option value="review-doc-count-responsive-and-privileged-docs">Review: Doc Count - Responsive and
                  Privileged Docs
                </mat-option>
                <mat-option value="review-doc-count-by-doc-type">Review: Doc Count by DocType</mat-option>
                <mat-option value="review-gigabytes-by-doc-type">Review: Gigabytes by Doc Type</mat-option>
                <mat-option value="custom">Custom</mat-option>
              </mat-select>
            </mat-form-field>
            <br>
            <div *ngIf="reportType === 'custom'" style="display: flex; gap: 20px; width: 60%">
              <mat-form-field appearance="outline" style="flex-grow: 1; width: 20%">
                <mat-label>Primary Field</mat-label>
                <mat-select [(ngModel)]="customReportPrimaryField" (ngModelChange)="refreshReport()">
                  <mat-option *ngFor="let field of caseAssessmentFields$ | async" [value]="field">{{field.name}}</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" style="flex-grow: 1; width: 20%">
                <mat-label>Optional Field</mat-label>
                <mat-select [(ngModel)]="customReportOptionalFieldId" (ngModelChange)="refreshReport()">
                  <mat-option [value]="builtInFields.HasBeenReviewed">Review Status</mat-option>
                  <mat-option [value]="builtInFields.IsKey">Key Document</mat-option>
                  <mat-option [value]="builtInFields.Responsive">Responsive</mat-option>
                  <mat-option [value]="builtInFields.Privilege">Attorney-Client Privilege</mat-option>
                  <mat-option [value]="builtInFields.WorkProduct">Attorney Work Product</mat-option>
                  <mat-option [value]="builtInFields.RedactForPrivilege">Privileged: Needs Redaction</mat-option>
                  <mat-option [value]="builtInFields.RedactForPi">Personal Information: Needs Redaction</mat-option>
                  <mat-option [value]="builtInFields.Confidential">Confidential</mat-option>
                  <mat-option [value]="builtInFields.Placeholder">Placeholder</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" style="flex-grow: 1; width: 20%">
                <mat-label>Date Unit</mat-label>
                <mat-select [(ngModel)]="customReportDateUnit" (ngModelChange)="refreshReport()">
                  <mat-option value="year-only">Year Only</mat-option>
                  <mat-option value="year-and-quarter">Year and Quarter</mat-option>
                  <mat-option value="year-and-month">Year and Month</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" style="flex-grow: 1; width: 20%">
                <mat-label>Metric</mat-label>
                <mat-select [(ngModel)]="customReportSumUnit" (ngModelChange)="refreshReport()">
                  <mat-option value="doc-count">Document Count</mat-option>
                  <mat-option value="pages">Pages</mat-option>
                  <mat-option value="gigabytes">Gigabytes</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

          </div>

          <div *ngIf="viewMode === 'table'" style="overflow: auto; height: 100%;">
            <table mat-table *ngIf="dataSource$ | async as dataSource" [dataSource]="dataSource" matSort
                   class="table-width" style="width: 100%">
              <ng-container *ngFor="let column of columnsToDisplay" [matColumnDef]="column">
                <th mat-header-cell *matHeaderCellDef matTooltip="In Review" style="width: 250px;"
                    [mat-sort-header]="column">
                  <span *ngIf="column === 'total'">Total</span>
                  <span *ngIf="column === 'pivot'">Pivot</span>
                  <span *ngIf="column !== 'total' && column !== 'pivot'">{{column}}</span>
                </th>
                <td mat-cell *matCellDef="let element">
                  <span *ngIf="column === 'pivot'">{{element.pivot}}</span>
                  <span *ngIf="column !== 'pivot'">{{element[column] | number}}</span>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
              <tr mat-row *matRowDef="let row; columns:columnsToDisplay"></tr>
            </table>
          </div>
          <div *ngIf="viewMode === 'graph' && isChartDataLoaded" style="overflow: auto; height: 100%;">
            <ngx-charts-bar-vertical
              [legend]="true"
              [showXAxisLabel]="true"
              [showYAxisLabel]="true"
              [xAxis]="true"
              [yAxis]="true"
              [xAxisLabel]="xAxisLabel"
              [yAxisLabel]="yAxisLabel"
              [results]="chartData"

            >
            </ngx-charts-bar-vertical>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
